// This file was auto-generated by Fern from our API Definition.
export const QueryQueriesRequestOrder = {
    Ascending: "ascending",
    Descending: "descending",
};
